// Shared visual config for call lifecycle status badges + dots.
// Both CallStatusPanel and SimulationCallStatusPanel render the same widgets;
// keeping the colour/pulse map in one place stops the two from drifting.

import type { CallLifecycleStatus } from '../stores/telemetryStore'

export const statusConfig: Record<CallLifecycleStatus, { color: string; pulse: boolean }> = {
  initiated: { color: 'bg-warning/20 text-warning', pulse: true },
  ringing: { color: 'bg-info/20 text-info', pulse: true },
  answered: { color: 'bg-success/20 text-success', pulse: false },
  active: { color: 'bg-success/20 text-success', pulse: true },
  voicemail: { color: 'bg-warning/20 text-warning', pulse: false },
  cancelling: { color: 'bg-warning/20 text-warning', pulse: true },
  ended: { color: 'bg-text-muted/20 text-text-secondary', pulse: false },
}

export const dotColor: Record<CallLifecycleStatus, string> = {
  initiated: 'bg-warning',
  ringing: 'bg-info',
  answered: 'bg-success',
  active: 'bg-success',
  voicemail: 'bg-warning',
  cancelling: 'bg-warning',
  ended: 'bg-text-muted',
}
